import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteFaqPage = {
  name: "deleteFaqPage" as const,
  input: z.object({ id: z.string() }),
  output: zExt.coercedResult(z.object({})),
};
